<template>
	<el-row>
		<el-button @click="add">创建剧本+</el-button>
		<el-row>
			<el-col :span="4">
				<span>剧本类型:</span>
				<el-select v-model="scenarioType">
					<el-option v-for="item in scenarioTypes" :key="item.value" :value="item.value" :label="item.label">
					</el-option>
				</el-select>
			</el-col>
			<el-col :span="6">
				<span>针对品类:</span>
				<el-cascader v-model="arr" :options="options" :props="props" style="width: 80%;">
				</el-cascader>
			</el-col>
			<el-col :span="8">
				<span>代理人设:</span>
				<el-select v-model="labelRelationId" clearable>
					<el-option v-for="item in options2" :key="item.id" :value="item.id" :label="item.name">
					</el-option>
				</el-select>
			</el-col>
			<el-col :span="5">
				<el-button @click="screen()" type="primary">筛选</el-button>
				<el-button @click="Export()">导出Excel</el-button>
				<el-button @click="reset()" type="success">重置</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-col>
				<el-table :data="tableData">
					<el-table-column label="序号" prop="id"></el-table-column>
					<el-table-column label="剧本类型" prop="scenarioType">
					</el-table-column>
					<el-table-column label="剧本名称" prop="scenarioName"></el-table-column>
					<el-table-column label="针对品类">
						<template slot-scope="scope">
							{{scope.row.primaryName}} --- {{scope.row.secondaryName}}
						</template>
					</el-table-column>
					<el-table-column label="代理人设" prop="labelVosName"></el-table-column>
					<el-table-column label="动作天数">
						<template slot-scope="scope">
							<span>{{scope.row.dayNumTotal}}天</span>
						</template>
					</el-table-column>
					<el-table-column label="创建人id" prop="createPerson"></el-table-column>
					<el-table-column label="更新时间" prop="updateTime"></el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button @click="editor(scope.row)" type="text" style="color: #a6e22e;">编辑
							</el-button>
							<el-button @click="toView(scope.row)" type="text">添加明细</el-button>
							<el-button @click="del(scope.row)" type="text" style="color: red;">删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="[30,60,100]" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
		<el-dialog :title="title" :visible.sync="dialogVisible" center>
			<el-form :model="info" ref="info" label-position="right" label-width="100px" :rules="infoRules">
				<el-form-item label="剧本类型" prop="scenarioType">
					<el-select v-model="info.scenarioType" :disabled="disabled">
						<el-option v-for="item in scenarioTypes" :key="item.value" :value="item.value"
							:label="item.label">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="剧本名称" prop="scenarioName">
					<el-input v-model="info.scenarioName"></el-input>
				</el-form-item>
				<el-form-item label="针对品类" prop="arr">
					<el-cascader style="width: 100%;" v-model="info.arr" :options="options" :props="props">
					</el-cascader>
				</el-form-item>
				<el-form-item label="代理人设" prop="labelIds">
					<el-cascader v-model="info.labelIds" :options="options2" :props="props2" clearable
						style="width: 100%;">
					</el-cascader>
				</el-form-item>
				<el-form-item label="推荐人群" prop="labelIdList">
					<el-cascader v-model="info.labelIdList" :options="options3" :props="props3" clearable
						style="width: 100%;">
					</el-cascader>
				</el-form-item>
				<el-form-item>
					<el-button type="infor" @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" @click="submit">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				disabled: false,
				scenarioType: '', //剧本类型
				scenarioName: '', //剧本名称
				arr: [],
				primaryType: '', //一级分类id
				secondary: '', //二级分类id
				labelRelationId: '', //人设id
				createPerson: '', //创建人id
				options: [], //品类集合
				options2: [], //人设集合
				options3: [],
				dialogVisible: false,
				title: '',
				info: {
					id: '',
					scenarioType: "",
					scenarioName: "",
					arr: [],
					labelIds: [],
					labelIdList: []
				},
				infoRules: {
					scenarioType: [{
						required: true,
						message: '请选择剧本类型',
						trigger: 'blur'
					}],
					scenarioName: [{
						required: true,
						message: '请填写剧本名称',
						trigger: 'blur'
					}],
					arr: [{
						required: true,
						message: '请选择针对品类',
						trigger: 'blur'
					}],
					labelIds: [{
						required: true,
						message: '请选择代理人设',
						trigger: 'blur'
					}],
					labelIdList: [{
						required: true,
						message: '请选择推荐人群',
						trigger: 'blur'
					}]
				},
				props: {
					value: "id",
					label: "name",
					children: "children",
				},
				props2: {
					value: "id",
					label: "name",
					children: "sonList",
					multiple: true
				},
				props3: {
					value: "id",
					label: "name",
					children: "sonList",
					multiple: true
				},
				tableData: [],
				total: 0,
				pageNum: 1,
				pageSize: 30,
				scenarioTypes: [{
						value: '01',
						label: '构建信任'
					},
					{
						value: '02',
						label: '拓新吸粉'
					},
					{
						value: '03',
						label: '产品种草'
					},
					{
						value: '04',
						label: '私聊话术'
					}
				]
			}
		},
		methods: {
			add() {
				this.title = '创建剧本'
				this.dialogVisible = true
				this.disabled = false
				this.info = {
					id: '',
					scenarioType: "",
					scenarioName: "",
					arr: [],
					labelIds: [],
				}
			},
			editor(row) {
				console.log(row);
				let scenarioType = row.scenarioType
				switch (row.scenarioType) {
					case "构建信任":
						scenarioType = '01'
						break;
					case "拓新吸粉":
						scenarioType = '02'
						break;
					case "私聊话术":
						scenarioType = '04'
						break;
					case "产品种草":
						scenarioType = '03'
						break;
				}
				this.dialogVisible = true
				this.title = '修改剧本'
				this.disabled = true
				this.info = {
					id: row.id,
					scenarioType: scenarioType,
					scenarioName: row.scenarioName,
					arr: [row.primaryType, row.secondary],
					labelIds: row.labelVosArr,
					labelIdList: row.labelVoList2
				}
			},
			toView(row) {
				let scenarioType = ''
				let parentId = ''
				let parentId2 = ''
				console.log(row);
				let labelVoList = []
				if (row.labelVoList) {
					row.labelVoList.forEach(i => {
						labelVoList.push(i.labelName)
					})
				}
				// if (row.labelVoList.length > 0) {
				// 	row.labelVoList.forEach(i => {
				// 		labelVoList.push(i.labelName)
				// 	})
				// }
				switch (row.scenarioType) {
					case "构建信任":
						scenarioType = '01'
						parentId = "60"
						parentId2 = "66"
						break;
					case "拓新吸粉":
						scenarioType = '02'
						parentId = "61"
						parentId2 = "67"
						break;
					case "产品种草":
						scenarioType = '03'
						parentId = "62"
						parentId2 = "68"
						break;
					case "私聊话术":
						scenarioType = '04'
						parentId = "63"
						parentId2 = "69"
						break;
				}
				this.$router.push({
					path: './scenarioDetails',
					query: {
						id: row.id,
						scenarioType: scenarioType,
						parentId: parentId,
						parentId2: parentId2,
						labelVosName: row.labelVosName,
						labelVoList3: row.labelVoList3,
						primaryName: row.primaryName,
						secondaryName: row.secondaryName
					}
				})
			},
			del(row) {
				this.$confirm('此操作将永久删除该剧本, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('/api/plant/positions/updateScenario', {
						"id": row.id,
						"deleteStatus": 1
					}).then(res => {
						console.log(res.data);
						if (res.data.status == 0) {
							this.$message({
								type: 'success',
								message: '删除成功'
							});
							this.getList()
						} else {
							this.$message({
								type: 'info',
								message: '已取消删除'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			submit() {
				console.log(this.info);
				let primaryType = ''
				let secondary = ''
				let labelIds = []
				let labelIdList = []
				if (this.info.arr.length > 0) {
					primaryType = this.info.arr[0]
					secondary = this.info.arr[1]
				}
				if (this.info.labelIds.length > 0) {
					this.info.labelIds.forEach(i => {
						labelIds.push(i[0])
					})
				}
				console.log(this.info.labelIdList);
				// return false
				if (this.info.labelIdList.length > 0) {
					this.info.labelIdList.forEach(i => {
						labelIdList.push(i[1])
					})
				}
				console.log(labelIdList);
				// return false
				this.$refs.info.validate(vai => {
					if (vai) {
						if (this.title == '创建剧本') {
							this.$http.post('/api/plant/positions/insertScenario', {
								"scenarioType": this.info.scenarioType, //剧本类型
								"scenarioName": this.info.scenarioName, //剧本名称
								"primaryType": primaryType, //一级品类编号
								"secondary": secondary, //二级品类编号
								"labelIds": labelIds, //标签集合
								"labelIdList": labelIdList,
								"createPerson": this.$store.state.userInfo.id //创建人ID
							}).then(res => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success(res.data.msg)
									this.dialogVisible = false
									this.getList()
								} else {
									this.$message.error(res.data.msg)
								}
							})
						} else {
							this.$http.post('/api/plant/positions/updateScenario', {
								"id": this.info.id,
								"scenarioType": this.info.scenarioType, //剧本类型
								"scenarioName": this.info.scenarioName, //剧本名称
								"primaryType": primaryType, //一级品类编号
								"secondary": secondary, //二级品类编号
								"labelIds": labelIds, //标签集合
								"labelIdList": labelIdList,
								"createPerson": this.$store.state.userInfo.id //创建人ID
							}).then(res => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success('修改成功')
									this.dialogVisible = false
									this.getList()
								} else {
									this.$message.error('修改失败')
								}
							})
						}
					}
				})

			},
			//筛选
			screen() {
				this.getList()
			},
			//导出
			Export() {
				let labelRelationId = ''
				if (this.arr.length > 0) {
					labelRelationId = this.arr[1]
				}
				this.$http.post('/api/statistics/knowledgeBase/exportScenario', {
					arr: [],
					"scenarioType": this.scenarioType, //剧本类型
					"secondary": this.scenarioName, //针对品类
					"labelRelationId": labelRelationId, //代理人设
				}, {
					responseType: 'blob'
				}).then((res) => {
					console.log(res);
					this.$message({
						type: 'info',
						message: '正在导出表格'
					});
					const link = document.createElement('a');
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					});
					link.style.display = 'none';
					//设置连接
					link.href = URL.createObjectURL(blob);
					link.download = '剧本列表';
					document.body.appendChild(link);
					//模拟点击事件
					link.click();
					window.URL.revokeObjectURL(link.href);
					link.remove();
				})
			},
			//重置
			reset() {
				this.scenarioType = '' //剧本类型
				this.arr = []
				this.primaryType = '' //一级分类id
				this.secondary = '' //二级分类id
				this.labelRelationId = '' //人设id
				this.getList()
			},
			getList() {
				if (this.arr.length > 0) {
					this.primaryType = this.arr[0]
					this.secondary = this.arr[1]
				}
				this.$http.post('/api/plant/positions/selectScenario', {
					"scenarioType": this.scenarioType, //剧本类型
					"primaryType": this.primaryType, //一级分类id
					"secondary": this.secondary, //二级分类id
					"labelRelationId": this.labelRelationId, //人设id
					"orderType": 0,
					"pageNum": this.pageNum,
					"pageSize": this.pageSize
				}).then(res => {
					console.log(res.data.data.list);
					if (res.data.data.list.length > 0) {
						res.data.data.list.forEach(i => {
							i.labelVosArr = []
							i.labelVosName = ''
							i.labelVoList2 = []
							i.labelVoList3 = ''
							let labelVoList = []
							let labelVosName = []
							if (i.labelVos.length > 0) {
								i.labelVos.forEach(item => {
									i.labelVosArr.push([item.labelId])
									labelVosName.push(item.labelName)
									i.labelVosName = labelVosName.join(',')
								})
							}
							if (i.labelVoList) {
								i.labelVoList.forEach(item => {
									i.labelVoList2.push([item.parentLabelId, item.labelId])
									labelVoList.push(item.labelName)
									i.labelVoList3 = labelVoList.join(',')
								})
							}
						})
					}
					this.tableData = res.data.data.list
					this.total = res.data.data.total
				})
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getList()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getList()
			},
			//获取分类
			getpaiCategory() {
				this.$http.get(
						"/api/product/productCategory/paiCategory?pageSize=999&pageNum=1&paiStatus=1", {}
					)
					.then((res) => {
						// console.log(res.data.data.list);
						this.options = res.data.data.list;
					});
			},
			//获取销售人群
			getinfo() {
				let arr = []
				this.$http.post("/api/plant/clrLabel/selectLabel", {
					"type": 4,
					"useStatus": 0
				}).then((res) => {
					res.data.data.forEach((item) => {
						this.options2.push({
							id: item.memberLabelId,
							name: item.name,
						})
					})
				});
			},
			getinfo3() {
				let arr = []
				this.$http.get("/api/plant/clrLabel/selectLabelList", {
					"type": 4,
					"useStatus": 0
				}).then((res) => {
					console.log(res.data.data);
					res.data.data.forEach((item) => {
						item.sonList.forEach(i => {
							arr.push({
								id: i.memberLabelId,
								name: i.name,
								sonList2: i.sonList
							})
						})
					});
					arr.forEach(i2 => {
						i2.sonList = []
						i2.sonList2.forEach(i3 => {
							i2.sonList.push({
								id: i3.memberLabelId,
								name: i3.name
							})
						})
					})
					this.options3 = arr
					console.log(arr);
				});
			},
		},
		created() {
			this.getpaiCategory()
			this.getinfo()
			this.getinfo3()
			this.getList()
		}
	}
</script>

<style scoped>
</style>
